export const MAIL_TO_PREFIX = "mailto:";

export const isMailToHref = (href: string | undefined | null): boolean => {
  return href?.startsWith(MAIL_TO_PREFIX) ?? false;
};
